import React from 'react';
import { Alert, Modal, Spinner } from 'react-bootstrap';
import { Show } from 'Layout';
import { PageStatus } from 'enums';
import { AuthAPI } from "../../API";

class EditForm extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            status: PageStatus.None,
            error: null,
            bannerNameEng: this.props.bannerData?.bannerNameEng || "",
            bannerNameHi: this.props.bannerData?.bannerNameHi || "",
            bannerImgName: "",
            bannerImgHiName: "",
            hasNewEngImage: false,
            hasNewHiImage: false,
            uploadsInProgress: 0,
        };
    }

    onSubmit() {
        if (this.state.uploadsInProgress > 0) {
            alert("Please wait for image upload to complete before submitting.");
            return;
        }
        const valuesIn: any = {
            id: Number(this.props.bannerData.id),
            bannerNameEng: this.state.bannerNameEng,
            bannerNameHi: this.state.bannerNameHi,
        };
        if (this.state.hasNewEngImage) {
            valuesIn.bannerImgName = this.state.bannerImgName;
        }
        if (this.state.hasNewHiImage) {
            valuesIn.bannerImgHiName = this.state.bannerImgHiName;
        }
        return Promise.resolve()
            .then(() => this.setState({ status: PageStatus.Submitting }))
            .then(() => AuthAPI.updatebanner(valuesIn))
            .then(() => {
                alert("Sweepstake image updated successfully.");
                this.props.onSubmit();
                return this.setState({ status: PageStatus.Submitted });
            })
            .catch((error) => {
                this.setState({ status: PageStatus.Error, error: error.message });
            });
    }

    handleBannerUpload(e, type) {
        try {
            this.setState((prev) => ({ status: PageStatus.Loading, uploadsInProgress: prev.uploadsInProgress + 1 }));
            const file = e.target.files[0];
            if (file) {
                const newDate = Date.now();
                const newName = file.name;
                const formData = new FormData();
                formData.append('image', file);
                formData.append('bannerName', newDate + '_' + newName.replaceAll(" ", "").split('.')[0]);
                AuthAPI.uploadUserProfilecopy(formData)
                    .then((data) => {
                        if (type == "Eng") { this.setState((prev) => ({ bannerImgName: data, hasNewEngImage: true, uploadsInProgress: prev.uploadsInProgress - 1, status: prev.uploadsInProgress - 1 > 0 ? PageStatus.Loading : PageStatus.None })) }
                        if (type == "Hi") { this.setState((prev) => ({ bannerImgHiName: data, hasNewHiImage: true, uploadsInProgress: prev.uploadsInProgress - 1, status: prev.uploadsInProgress - 1 > 0 ? PageStatus.Loading : PageStatus.None })) }
                    })
                    .catch((err) => {
                        console.error(err);
                        this.setState((prev) => ({ error: err.message, uploadsInProgress: prev.uploadsInProgress - 1, status: prev.uploadsInProgress - 1 > 0 ? PageStatus.Loading : PageStatus.None }));
                    });
            } else {
                this.setState((prev) => ({ uploadsInProgress: prev.uploadsInProgress - 1, status: prev.uploadsInProgress - 1 > 0 ? PageStatus.Loading : PageStatus.None }));
            }
        } catch (error) {
            this.setState((prev) => ({ error: error.message, uploadsInProgress: prev.uploadsInProgress - 1, status: PageStatus.None }))
        }
    }

    render() {
        return (
            <Modal
                centered
                size="lg"
                backdrop="static"
                onHide={this.props.onClose}
                show={this.props.show}
                style={{ zIndex: 1201 }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Update Image</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: '78vh', overflow: 'auto' }}>
                    <Alert variant="danger" show={this.state.status === PageStatus.Error}>
                        {this.state.error}
                    </Alert>

                    <form onSubmit={(e) => { e.preventDefault(); this.onSubmit(); }}>
                        <div className="row">
                            <div className="col">
                                <label htmlFor="bannerNameEng">Sweepstake English Name*</label>
                                <input
                                    type="text"
                                    className='form-control'
                                    value={this.state.bannerNameEng}
                                    onChange={(e) => { this.setState({ bannerNameEng: e.target.value }) }}
                                    id="bannerNameEng"
                                    placeholder="Enter here"
                                    required
                                />
                            </div>
                            <div className="col">
                                <label htmlFor="bannerNameHi">Sweepstake Hindi Name*</label>
                                <input
                                    type="text"
                                    className='form-control'
                                    value={this.state.bannerNameHi}
                                    onChange={(e) => { this.setState({ bannerNameHi: e.target.value }) }}
                                    id="bannerNameHi"
                                    placeholder="Enter here"
                                    required
                                />
                            </div>
                        </div>

                        <div className="row mt-2">
                            <div className="col">
                                <label htmlFor="bannerImgName">English Image (leave empty to keep current)</label>
                                <input
                                    className="form-control"
                                    name="bannerImgName"
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => this.handleBannerUpload(e, "Eng")}
                                    placeholder="Enter here"
                                />
                            </div>
                            <div className="col">
                                <label htmlFor="bannerImgHiName">Hindi Image (leave empty to keep current)</label>
                                <input
                                    className="form-control"
                                    name="bannerImgHiName"
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => this.handleBannerUpload(e, "Hi")}
                                    placeholder="Enter here"
                                />
                            </div>
                        </div>

                        <hr />
                        <div className="d-flex align-items-center mt-2">
                            <Show when={this.state.status === PageStatus.Loading || this.state.status === PageStatus.Submitting}>
                                <div className="mr-3">
                                    <Spinner animation="border" variant="primary" />
                                </div>
                            </Show>
                            <Show when={this.state.status !== PageStatus.Loading && this.state.status !== PageStatus.Submitting}>
                                <button
                                    type="submit"
                                    className="btn btn-primary mr-3"
                                >
                                    Update
                                </button>
                            </Show>
                            <button
                                type='button'
                                onClick={this.props.onClose}
                                className="btn btn-light mr-3"
                            >
                                Cancel
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        );
    }
}

export { EditForm };
